<body [ngClass]="isModal ? 'showModal': ''">
  <header>
    <div class="d-flex justify-content-center">
      <h5 id="heading" class="text-dark" style="font-size: 14px;">Liste des éléments constituant le dossier</h5>
      <button *ngIf="isModal" type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()" >
        <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
      </button>
    </div>
  </header><br>
  
  <div class="container">
    <div class="accordion">
      <div class="accordion-item shadow p-2 mb-2">
        <a  id="accordion-button-1" aria-expanded="false"><span class="accordion-title">Requisitoires <span class="badge badge-danger text-light">{{list_requisitoires?.length}}</span></span><span class="icon" aria-hidden="true"></span></a>
        <div class="accordion-content">
         
            <section class=" d-flex justify-content-between" *ngIf="list_requisitoires?.length > 0; else vide_req">
              <div class="card col-lg-3 col-md-3 col-xl-3 col-sm-10 col-xs-11" *ngFor="let item of list_requisitoires | paginate: { itemsPerPage: 9, currentPage: pageReq, id: 'req' }"  (click)="openModalVisualrequistion(item)">
                <div class="d-flex justify-content-start align-items-center">
                  <i class="fas fa-regular fa-file "></i>
                  <p class="text-start mt-1">{{ item.name }}</p>
                </div>
              </div>
            </section>
            <pagination-controls  (pageChange)="pageReq = $event" previousLabel="" nextLabel=""
            responsive="true" [id]="'req'"></pagination-controls>
            <ng-template #vide_req>
              <p>acun requisitoire</p>
            </ng-template>
        
        </div>
      </div>
      <div class="accordion-item shadow p-2 mb-2">
        <a id="accordion-button-2" aria-expanded="false"><span class="accordion-title">Ordonnances <span class="badge badge-danger text-light">{{list_ordonnances?.length}}</span></span><span class="icon" aria-hidden="true"></span></a>
        <div class="accordion-content">
          <section class=" d-flex justify-content-between" *ngIf="list_ordonnances?.length > 0;else vide_ord">
            <div class="card col-lg-3 col-md-3 col-xl-3 col-sm-10 col-xs-11"  *ngFor="let item of list_ordonnances | paginate: { itemsPerPage: 9, currentPage: pageOrd, id: 'ord' }"  (click)="openModalVisualrequistion(item)">
              <div class="d-flex justify-content-start align-items-center">
                <i class="fas fa-regular fa-file "></i>
                <p class="text-start mt-1">{{ item.name }}</p>
              </div>
            </div>
          </section>
          <pagination-controls  (pageChange)="pageOrd = $event" previousLabel="" nextLabel=""
          responsive="true" [id]="'ord'"></pagination-controls>
          <ng-template #vide_ord>
            <p>acune ordonnance</p>
          </ng-template>
        </div>
      </div>
      <div class="accordion-item shadow p-2 mb-2">
        <a id="accordion-button-3" aria-expanded="false"><span class="accordion-title">pieces <span class="badge badge-danger text-light">{{pieces?.length}}</span></span><span class="icon" aria-hidden="true"></span></a>
        <div class="accordion-content">
          <section class=" d-flex flex-wrap justify-content-between" *ngIf="pieces?.length > 0; else vide_p">
            <div class="card col-lg-3 col-md-3 col-xl-3 col-sm-10 col-xs-11" *ngFor="let item of pieces | paginate: { itemsPerPage: 9, currentPage: pagePiece, id: 'piece' }"  (click)="openModalVisualPiece(item)">
              <div class="d-flex justify-content-start flex-wrap align-items-center">
                <i class="fas fa-regular fa-file "></i>
                <p class="text-start mt-1 text-wrap">{{ item.nom_du_fichier}}</p>
              </div>
            </div>
          </section>
          <pagination-controls  (pageChange)="pagePiece = $event" previousLabel="" nextLabel=""
          responsive="true" [id]="'piece'"></pagination-controls>
          <ng-template #vide_p>
            <p>acune piece</p>
          </ng-template>
        </div>
      </div>
      <div class="accordion-item shadow p-2 mb-2">
        <a id="accordion-button-4" aria-expanded="false"><span class="accordion-title">Documents <span class="badge badge-danger text-light">{{docs?.length}}</span></span><span class="icon" aria-hidden="true"></span></a>
        <div class="accordion-content">
          <section class=" d-flex flex-wrap  justify-content-between"  *ngIf="docs?.length > 0; else vide_doc">
            <div class="card col-lg-3 col-md-3 col-xl-3 col-sm-10 col-xs-11" *ngFor="let item of docs | paginate: { itemsPerPage: 9, currentPage: pageDocs, id: 'doc' }"  (click)="openModalDetailDocument(item, 'document')">
              <div class="d-flex justify-content-start align-items-center">
                <i class="fas fa-regular fa-file "></i>
                <p class="text-start mt-1 text-wrap ">{{ item.name}}</p>
              </div>
            </div>
          </section>
          <pagination-controls  (pageChange)="pageDocs = $event" previousLabel="" nextLabel=""
          responsive="true" [id]="'doc'"></pagination-controls>
          
          <ng-template #vide_doc>
            <p>acun document</p>
          </ng-template>
        </div>
      </div>

      <!-- <div class="accordion-item shadow p-2 mb-2">
        <a id="accordion-button-5" aria-expanded="false"><span class="accordion-title">Audiences <span class="badge badge-danger text-light">{{audiences?.length}}</span></span><span class="icon" aria-hidden="true"></span></a>
        <div class="accordion-content">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">N°Audience</th>
                <th scope="col">Date audience</th>
                <th scope="col">Statut</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of audiences | paginate: { itemsPerPage: 10, currentPage: pageAudience, id: 'audience' }"  (click)="openModalDetailJugement(item)" style="cursor: pointer;">
                <th scope="row">{{item.numero_de_jugement}}</th>
                <td>{{getFormattedDate(item.date_de_jugement)}}</td>
                <td > <span class="bg-primary text-light">{{item.status}}</span> </td>
                <td>
                  
                    <i class="fas fa-solid fa-eye text-primary" style="font-size: 16px;"></i>
                </td>
              </tr>
            
            </tbody>
          </table>
          
          <pagination-controls  (pageChange)="pageAudience = $event" previousLabel="" nextLabel=""
          responsive="true" [id]="'audience'"></pagination-controls>
          
          <ng-template #vide_doc>
            <p>acun document</p>
          </ng-template>
        </div>
      </div> -->
      
    
    </div>
  </div>
  
  
  
</body>